import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { en } from './locales/en'
import { fi } from './locales/fi'

// This package owns the i18next singleton: the shell has no strings of its own,
// and initialising on import keeps the ordering problem (detector before first
// render) out of the shell's main.tsx.
export const i18n = i18next.createInstance()

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fi: { translation: fi },
      en: { translation: en },
    },
    fallbackLng: 'en',
    supportedLngs: ['fi', 'en'],
    interpolation: { escapeValue: false },
    // There is no language switcher in this app, so nothing is gained by
    // persisting a detected language across sessions — detection re-runs
    // from the browser's own settings on every load either way. Restricting
    // detection to `navigator` (and disabling the cache) also keeps
    // LanguageDetector from probing localStorage during init, which the
    // default `order` does even with an empty `caches` list.
    detection: { order: ['navigator'], caches: [] },
  })
